import React from "react";

import { useTheme } from "@mui/material";
import { DangerOutlinedButton, SecondaryButton } from "@shared/CustomButton";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

export type ActionCellProps = {
    product: API.Product;
    isDeleting: boolean;
    onDelete: (id: number) => void;
    setEditProductId: (id: number | null) => void;
    setConfigProduct: React.Dispatch<React.SetStateAction<API.Product | null>>;
};

export const ActionCell = (props: ActionCellProps) => {
    const theme = useTheme();
    return (
        <MinimalTableCell align="right">
            <SecondaryButton
                style={{ marginRight: theme.spacing(1) }}
                tooltipProps={{ title: "Edit product" }}
                onClick={() => {
                    props.setEditProductId(props.product.id);
                }}
            >
                <i className="fa-solid fa-pencil" />
            </SecondaryButton>
            <SecondaryButton
                style={{ marginRight: theme.spacing(1) }}
                tooltipProps={{ title: "Show config" }}
                size="small"
                onClick={() => {
                    props.setConfigProduct(props.product);
                }}
            >
                <i className="fa-solid fa-code" />
            </SecondaryButton>
            <DangerOutlinedButton onClick={() => props.onDelete(props.product.id)} loading={props.isDeleting}>
                <i className="fa-solid fa-trash-alt" />
            </DangerOutlinedButton>
        </MinimalTableCell>
    );
};
